// libs
import { createContext, useContext } from 'react';

import { Message } from '../types';

export const MessageItemContext = createContext<Message | null>(null);

export const useMessageItemContext = () => {
  const value = useContext(MessageItemContext);

  if (!value) {
    throw new Error('[MessageItemContext] Not initialised');
  }

  return value;
};
